import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

/**
 * Checks if the current merchant has Zalando integration access
 * by querying the zalando_merchant_access table (RLS-protected).
 */
export function useZalandoAccess(shopId: string | null) {
  const [hasAccess, setHasAccess] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!shopId) {
      setHasAccess(false);
      setLoading(false);
      return;
    }

    let cancelled = false;

    (async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('zalando_merchant_access')
        .select('merchant_id')
        .eq('merchant_id', shopId)
        .maybeSingle();

      if (!cancelled) {
        setHasAccess(!error && !!data);
        setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [shopId]);

  return { hasAccess, loading };
}
